const columns = [
  { name: 'code', title: 'Code' },
  { name: 'percent', title: 'Prozente %' },
];

export default columns;
